/**
 * set dom element sticky relative to parent container for .s-sticky-panel selectors
 */
import * as lib from '../lib/lib'
import jQuery from 'jquery'

class StickToParent {
  constructor(element) {
    if (!element) {
      return false
    }

    this.$element = jQuery(element)

    jQuery(window).resize(() => {
      this.ini()
    })

    jQuery(window).on('scroll', () => {
      this.ini()
    })
  }

  ini() {
    const stickyParent = this.$element
    const stickySidebar = jQuery('.sticky-sidebar', stickyParent)
    const stickySidebarHeight = stickySidebar.outerHeight()
    const stickyElement = jQuery('.sticky-element', stickyParent)
    const stickyElementHeight = stickyElement.outerHeight()
    const stickyGap = jQuery('.sticky-gap', stickyParent)
    const stickyGapHeight = stickyGap.length ? stickyGap.outerHeight() : 0
    // const headerOffset = jQuery('body').hasClass('menu-is-sticky')
    //   ? jQuery('header').outerHeight()
    //   : 0
    const headerOffset = jQuery('header').outerHeight()
    const leaseItNowBarOffset = jQuery('.s-leaseitnow-car-bar').outerHeight()
    const pad = 20

    if (!stickyParent.length) {
      return false
    }

    if (lib.scrDevices()) {
      stickyElement.removeAttr('style')
      return false
    }

    const dif = stickyParent.offset().top - jQuery(window).scrollTop()

    let translateY =
      -dif - stickyGapHeight + headerOffset + leaseItNowBarOffset + pad

    if (dif < -stickyGapHeight) {
      stickyElement.css('transform', `translateY(${translateY}px)`)
    } else {
      stickyElement.removeAttr('style')
    }

    const overlap =
      stickyGapHeight + stickyElementHeight + translateY - stickySidebarHeight

    if (overlap > 0) {
      translateY = translateY - overlap
      stickyElement.css('transform', `translateY(${translateY}px)`)
    }
  }
}
export default StickToParent
